import { React, useState } from "react";
import NyliaButton from "../nyliaButton/NyliaButton.js";
import "./Classes.css";
import Footer from "../Footer";
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ClassPopup from "./ClassPopup.js";
import * as classesConstants from "./ClassesConstants.js";

import WeeklySchedule from "../../assets/classesPage/Weekly Schedule.png";

function getDayOfWeek(date) {
  const dayOfWeek = new Date(date).getDay();
  return isNaN(dayOfWeek)
    ? null
    : [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ][dayOfWeek];
}

function filterClassesByDate(dayOfWeekStr) {
  var result = classesConstants.classDetails.filter((classItem) =>
    classItem.classTimes.some((times) => dayOfWeekStr.includes(times.weekDay))
  );

  return (
    result
      // .sort(
      //   (a, b) =>
      //     a.find((u) => u.classTimes.weekDay === dayOfWeekStr).classTimes -
      //     b.find((u) => u.classTimes.weekDay === dayOfWeekStr)
      // )
      .map((obj) => ({
        ...obj,
        curDayOfWeekStr: dayOfWeekStr,
      }))
  );
}

function Classes() {
  // For displaying the classes of the day.
  const [dailyClasses, setDailyClasses] = useState(
    filterClassesByDate(getDayOfWeek(new Date()))
  );

  function renderClassCards() {
    return (
      <Row
        xs={1}
        sm={2}
        md={2}
        lg={3}
        xl={3}
        className="g-4"
        style={{ margin: 0 }}
      >
        {dailyClasses.map((item, idx) => (
          <Col key={idx}>
            {console.log(item)}
            <ClassPopup
              className={item.className}
              description={item.description}
              requirements={item.requirements}
              imgId={item.imgId}
              registrationReq={item.registrationReq}
              classTimes={item.classTimes}
              dropInOrRegs={item.dropInOrRegs}
              curDayOfWeekStr={item.curDayOfWeekStr}
            />
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <div className="main-container class-container">
      <div className="main-img-bkg" id="classes-section">
        <div className="main-title">
          <h1>CLASSES</h1>
        </div>
        <div className="main-box">
          <p>
            <br />
            Explore our daily schedule, review detailed class information, and
            discover the classes best suited to support your training and
            growth.
          </p>
          <NyliaButton link="/enroll" label={"Enroll"}></NyliaButton>
        </div>
      </div>

      <div className="main-bkg" id="dailyClassesSection">
        <div>
          <Nav
            justify
            variant="tabs"
            className="justify-content-center"
            defaultActiveKey={new Date().getDay()}
          >
            <Nav.Item>
              <Nav.Link
                eventKey="1"
                onClick={() => setDailyClasses(filterClassesByDate("Monday"))}
              >
                MON
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="2"
                onClick={() => setDailyClasses(filterClassesByDate("Tuesday"))}
              >
                TUE
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="3"
                onClick={() =>
                  setDailyClasses(filterClassesByDate("Wednesday"))
                }
              >
                WED
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="4"
                onClick={() => setDailyClasses(filterClassesByDate("Thursday"))}
              >
                THU
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="5"
                onClick={() => setDailyClasses(filterClassesByDate("Friday"))}
              >
                FRI
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="6"
                onClick={() => setDailyClasses(filterClassesByDate("Saturday"))}
              >
                SAT
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="disabled" disabled>
                SUN
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
        <div> {renderClassCards()}</div>
      </div>
      <div className="main-img-bkg" id="schedule-download-section">
        <div className="main-box">
          <p>
            <br />
            To view the full class schedule, upcoming sessions, and all
            available training times, click the button below! Whether you're
            ready to commit or just want to check things out, everyone is
            welcome to join us for drop-ins or try a free trial class to
            experience the atmosphere, coaching, and community firsthand. We’d
            love to have you train with us!
          </p>
          <NyliaButton
            link={WeeklySchedule}
            label={"Class Schedule"}
          ></NyliaButton>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}
export default Classes;
